import { useDispatch } from "react-redux";
import { emptyCamera, selectCamera, getCameras } from "../redux/actions/types/cameraTypes";
import { useCallback, useEffect, useRef } from "react";
import { useStore } from "./useStore";

const useCamera = () => {
  const dispatch = useDispatch();
  const { cameraStore } = useStore();
  const cameraStoreRef = useRef(cameraStore);
  cameraStoreRef.current = cameraStore;

  useEffect(() => {}, [cameraStore.deviceId]);

  useEffect(() => {
    if (cameraStore.cameras.length === 0) {
      getListOfCameras();
    }
  }, [cameraStore.deviceId]);

  const getListOfCameras = useCallback(() => {
    if ("mediaDevices" in navigator && "enumerateDevices" in navigator.mediaDevices) {
      navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          console.log(devices, "devices");
          const devicesFilters = devices.filter((device) => device.kind === "videoinput");
          if (devicesFilters.length > 0) {
            dispatch(getCameras(devicesFilters));
          } else {
            dispatch(emptyCamera());
          }

          const currentStore = cameraStoreRef.current;
          const backCamera = devicesFilters.find((device) => {
            const label = device.label.toLowerCase();
            return (
              label.includes("back") ||
              label.includes("rear") ||
              label.includes("trasera") ||
              label.includes("trasero") ||
              label.includes("environment")
            );
          });

          const currentDeviceIsValid = devicesFilters.some(
            (device) => device.deviceId === currentStore.deviceId
          );

          if (currentStore.deviceId === "" || !currentDeviceIsValid || !currentStore.label) {
            const defaultCamera = backCamera || devicesFilters[0];
            if (defaultCamera) {
              dispatch(selectCamera(defaultCamera));
            }
          }
        })
        .catch(function (err) {
          console.info(err.name + ": " + err.message);
        });
    } else {
      dispatch(emptyCamera());
    }
  }, [dispatch]);

  const getStream = useCallback(() => {
    const constraints = {
      video: {
        width: {
          min: 1280,
          ideal: 1920,
          max: 2560,
        },
        height: {
          min: 720,
          ideal: 1080,
          max: 1440,
        },
        facingMode: "environment",
      },
    };
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        console.info(stream);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return { getListOfCameras, getStream };
};

export default useCamera;
